import { LanguageStatisticsPresenter } from '@/presentation/presenters/dashboard/languageStatisticsPresenter'
import { StatisticsViewModel } from '@/presentation/viewmodels/dashboard/statisticsViewModel'

export function useLanguageStatisticsPresenter(
  presenter: LanguageStatisticsPresenter = new LanguageStatisticsPresenter(new StatisticsViewModel())
) {
  return {
    isLoading: presenter.isLoading,
    error: presenter.error,
    chartData: presenter.chartData,
    chartSeries: presenter.chartSeries,
    chartOptions: presenter.chartOptions,
    initChart: presenter.initChart.bind(presenter)
  }
}
